import React, { Component } from 'react'
import { connect } from 'react-redux'
import Grid from '@mui/material/Grid'

import styles from './itens.module.css'
import { VISAO_POR_AUDITOR_AGRUPADOR } from '../../actions/itensPorVisaoActions'
import VisaoPorAuditor from './visoes/VisaoPorAuditor'

const visoes = {
  [VISAO_POR_AUDITOR_AGRUPADOR]: VisaoPorAuditor
}

export class AbaItens extends Component {
  render() {
    const {
      filtros: { visao }
    } = this.props
    const Visao = visoes[visao]
    return (
      <Grid container spacing={2} justifyContent='center' className={styles.gridContainer}>
        <Visao />
      </Grid>
    )
  }
}

const mapStateToProps = ({ filtros }) => ({ filtros })

export default connect(mapStateToProps)(AbaItens)
